<!-- eslint-disable max-len -->
<template>
  <div id="board-page-detail">
    <div class="board-page-detail--header">
      <div
        v-if="isDetail"
        style="height: 42px;">
        <h4>{{ board.name }}</h4>
        <p>ID: {{ board.id }}</p>
      </div>
    </div>
    <j-tabs
      v-if="isDetail"
      :tabs="tabs">
      <div
        id="tabs-component-container"
        class="tab-content">
        <div
          v-for="i in tabs"
          :key="i.id"
          :id="i.idComp"
          :aria-labelledby="i.idTab"
          role="tabpanel"
          class="tab-pane" >
          <component
            :is="i.comp.name"
            :board="board"/>
        </div>
      </div>
    </j-tabs>

    <j-loading-screen
      ref="loading"
      :message="loadingMessage"/>

    <j-problem-screen
      ref="problem"
      :message="problemMessage"/>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, max-len */
import jBoardGeneralTab from '@/views/board/tabs/jBoardGeneralTab';
import jBoardStageTab from '@/views/board/tabs/jBoardStageTab';
import jBoardLabelTab from '@/views/board/tabs/jBoardLabelTab';
import jBoardMemberTab from '@/views/board/tabs/jBoardMemberTab';
import jBoardVisibilityTab from '@/views/board/tabs/jBoardVisibilityTab';
import jBoardReminderTab from '@/views/board/tabs/jBoardReminderTab';

export default {
  components: {
    jBoardGeneralTab,
    jBoardStageTab,
    jBoardLabelTab,
    jBoardMemberTab,
    jBoardVisibilityTab,
    jBoardReminderTab,
  },

  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      category: false,
      isDetail: false,
      idForm: null,
      processing: false,
      loadingMessage: '',
      problemMessage: '',
      tabs: [
        {
          idTab: 'tabs-board-1', title: 'GENERAL', idComp: 'comps-board-1', comp: jBoardGeneralTab, isShow: true, isActive: true,
        },
        {
          idTab: 'tabs-board-2', title: 'STAGE', idComp: 'comps-board-2', comp: jBoardStageTab, isShow: true, isActive: false,
        },
        // {
        //   idTab: 'tab-sboard-3', title: 'LABEL', idComp: 'comps-board-3', comp: jBoardLabelTab, isShow: true, isActive: false,
        // },
        {
          idTab: 'tabs-board-4', title: 'MEMBER', idComp: 'comps-board-4', comp: jBoardMemberTab, isShow: true, isActive: false,
        },
        {
          idTab: 'tabs-board-5', title: 'VISIBILITY', idComp: 'comps-board-5', comp: jBoardVisibilityTab, isShow: true, isActive: false,
        },
        {
          idTab: 'tab-sboard-6', title: 'REMINDER', idComp: 'comps-board-6', comp: jBoardReminderTab, isShow: true, isActive: false,
        },
      ],
    };
  },
  computed: {

  },
  created() {
    // if the page mode is detail not add
    if (this.board !== null) {
      this.isDetail = true;
    }
  },
  methods: {

  },
};
</script>

<style lang="scss">
  .move {
    cursor: move;
  }

  #board-page-detail .board-page-detail--header {
    border: solid 1px #f1f1f1;
    // border-top-right-radius: 8px;
    // -webkit-box-shadow: 0 2px 8px 0 rgba(150,149,149,0.21);
    // box-shadow: 0 2px 8px 0 rgba(150,149,149,0.21);
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 15px;
    border-bottom: 0;
    background-color: #FCFDFE;
  }

  #board-page-detail .jTabsa .greedy-menu {
    -webkit-box-shadow: 2px 5px 12px -11px rgba(0,0,0,0.5);
   box-shadow: 2px 5px 12px -11px rgba(0,0,0,0.5);
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 0;
    background-color: #FCFDFE;
  }

  #board-page-detail .jTabsa .greedy-menu ul:first-of-type li a {
    color: #9a9a9a;
    font-weight: bold;
  }

  #board-page-detail .jTabsa .greedy-menu ul:first-of-type li a[aria-selected=true] {
    color: #5b5a5a;
    border: none;
    border-bottom: 4px solid #4a90e2;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    z-index: 3;
  }

  .btn-action {
    width: 100%;
    margin-top: 40px;
  }

  .close-button {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/board/jBoardSettingDetail.vue